/* Mouillette · barras de envío gratis y 10% al por mayor en el carrito lateral */
(function () {
  var MOU = window.MOU || {};
  var S = MOU.settings || {};
  var money = function (cents) {
    return '$' + Math.round((Number(cents) || 0) / 100).toLocaleString('es-CO');
  };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var truck = '<svg class="boost__ico" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';

  function boostHTML(c) {
    var min = Number(S.wholesaleMin) || 6;
    var off = Number(S.wholesalePct) || 10;
    var fsMin = (Number(S.freeShippingMin) || 0) * 100;
    var count = c.item_count || 0;
    var total = c.total_price || 0;
    var html = '<div class="boost">';
    if (fsMin > 0) {
      var left = fsMin - total;
      var pct = Math.min(100, Math.round((total / fsMin) * 100));
      html += '<div class="boost__card boost__card--ship' + (left <= 0 ? ' is-ok' : '') + '">' + truck +
        '<p class="boost__txt">' + (left <= 0
          ? '<strong>¡Tienes ENVÍO GRATIS!</strong> Se descuenta solo al pagar.'
          : 'Te faltan <strong>' + money(left) + '</strong> para <strong>ENVÍO GRATIS</strong>') +
        '</p><div class="boost__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div></div>';
    }
    var missing = min - count;
    var dots = '';
    for (var i = 1; i <= min; i++) dots += '<span' + (i <= count ? ' class="on"' : '') + '></span>';
    html += '<div class="boost__card boost__card--ws' + (count >= min ? ' is-ok' : '') + '"><span class="boost__badge">' + off + '% OFF</span>' +
      '<p class="boost__txt">' + (count >= min
        ? '<strong>¡Precio al por mayor activado!</strong> ' + off + '% de descuento. ' + esc(S.wholesaleNote || '')
        : 'Agrega <strong>' + missing + ' ' + (missing === 1 ? 'perfume' : 'perfumes') + ' más</strong> y llévate <strong>' + off + '% OFF</strong> por compra al por mayor.') +
      '</p><div class="boost__dots" aria-hidden="true">' + dots + '</div></div>';
    return html + '</div>';
  }

  function patch() {
    var Cart = MOU.Cart;
    if (!Cart || Cart.__boost) return false;
    Cart.__boost = true;
    Cart.wholesaleHTML = function () { return boostHTML(this.state || {}); };
    var render = Cart.render.bind(Cart);
    Cart.render = function () {
      render();
      var c = this.state;
      var row = document.querySelector('[data-cart-savings]');
      if (!c || !row) return;
      var disc = c.total_discount || 0;
      row.hidden = !(disc > 0);
      var amt = row.querySelector('[data-cart-savings-amt]');
      if (amt) amt.textContent = '−' + money(disc);
    };
    if (Cart.state) Cart.render();
    return true;
  }
  if (!patch()) {
    document.addEventListener('DOMContentLoaded', patch);
    window.addEventListener('load', patch);
  }
})();
